export default __webpack_public_path__ + "static/media/openshift-legend-icon-new.e6077c9c.svg";